import api from "../../utils/api";
import { setAlert } from './alert';
import {
  LOADING,
  CREATE_NEW_PERK,
  UPDATE_NEW_PERK,
  GET_PERK_DATA,
  DELETE_PERK_DATA,
  GET_EMAIL_NOTIFICATION,
} from "../types";

// get perk
export const getPerkData = () => async (dispatch) => {
  try {
    dispatch({ type: LOADING });
    const res = await api.get('/perk');
    dispatch({
      type: GET_PERK_DATA,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

// get perk
export const getPerkDataByUsername = (username) => async (dispatch) => {
  try {
    dispatch({ type: LOADING });
    const res = await api.get(`/perk/${username}`);
    dispatch({
      type: GET_PERK_DATA,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

// create perk
export const createPerk = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/perk/create`, data,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    dispatch({
      type: CREATE_NEW_PERK,
      payload: res.data
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}
// create perk
export const updatePerk = (data) => async (dispatch) => {
  try {
    const res = await api.post(`/perk/update`, data,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    dispatch({
      type: UPDATE_NEW_PERK,
      payload: res.data
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const deletePerk = (data) => async (dispatch) => {

  try {
    const res = await api.post('/perk/delete', data);
    dispatch({
      type: DELETE_PERK_DATA,
      payload: data.id
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const customizePerkPage = (data) => async (dispatch) => {
  try {
    const res = await api.post('/perk/customize', data,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const getPerkFormData = (username) => async (dispatch) => {
  try {
    const res = await api.get(`/perk/get-form/${username}`);
    dispatch({
      type: GET_EMAIL_NOTIFICATION,
      payload: res.data
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}

export const increasePerkFormVisitCount = (perkId) => async (dispatch) => {
  try {
    const res = await api.get(`/perk/increase-perk-form-visit-count/${perkId}`);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'error')));
    }
  }
}
